import { prettifyJson } from '../utils/prettifyJson';

export function prettifyCode(example: object | string): string {
  if (typeof example === 'object') {
    return prettifyJson(example);
  }

  if (typeof example === 'string') {
    return example;
  }
  return '';
}
